import {
  collection,
  doc,
  getDocs,
  increment,
  serverTimestamp,
  setDoc
} from "firebase/firestore";
import { db } from "../firebase";

const COLLECTION_NAME = "gamePopularity";

export const incrementGameClick = async (game) => {
  if (!game?.id) return;

  const ref = doc(db, COLLECTION_NAME, game.id);
  await setDoc(
    ref,
    {
      gameId: game.id,
      title: game.title || "",
      slug: game.slug || "",
      clicks: increment(1),
      updatedAt: serverTimestamp()
    },
    { merge: true }
  );
};

export const getPopularityMap = async () => {
  const snap = await getDocs(collection(db, COLLECTION_NAME));
  const map = {};

  snap.forEach((item) => {
    const data = item.data() || {};
    const gameId = typeof data.gameId === "string" ? data.gameId : item.id;
    const clicks = Number(data.clicks) || 0;
    if (gameId) {
      map[gameId] = clicks;
    }
  });

  return map;
};
